<template>
  <div id="app">
    <router-view />
    <bottom-nav v-if="shouldShowBottomNav" />
  </div>
</template>

<script>
import BottomNav from './components/BottomNav.vue';

export default {
  name: 'App',
  components: {
    BottomNav
  },
  computed: {
    shouldShowBottomNav() {
      const hiddenRoutes = ['VipPage', 'GroupBuyHome', 'GroupBuyDetail', 'MyGroupBuys'];
      return !hiddenRoutes.includes(this.$route.name);
    }
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      console.log('检查用户登录状态');
    }
  }
};
</script>

<style>
/* 全局样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #faf8f5;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  padding-bottom: 60px; /* 为底部导航留出空间 */
}

/* 隐藏滚动条但保留功能 */
::-webkit-scrollbar {
  display: none;
}

* {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
